import _extends from "@babel/runtime/helpers/extends";
// third party imports
import MediaQuery from 'mediaquery';
import hasDom from 'has-dom';
import { assertMediaTypeIs } from './assertMediaTypeIs';
import { getOrderMap } from './getOrderMap';
import { getMediaValue } from './getMediaValue';
import { assertMediaTypePosition } from './assertMediaTypePosition';
export var ResponsiveState = /*#__PURE__*/function () {
  function ResponsiveState(options) {
    this.options = Object.assign({}, {
      breakpoints: {
        xs: 767,
        sm: 1023,
        md: 1299
      },
      infinity: 'lg',
      orientation: 'portrait',
      // assume we on a phone and we hold it like everyone else
      extraFields: function extraFields() {
        return {};
      }
    }, options);

    // add `infinity` breakpoint for upper bound
    this.options.breakpoints[this.options.infinity] = Infinity;
    this.mediaQueries = {
      breakpoints: MediaQuery.asObject(this.options.breakpoints),
      orientation: {
        portrait: '(orientation: portrait)',
        landscape: '(orientation: landscape)'
      }
    };

    // set media order
    this.mediaOrder = getOrderMap(this.options.breakpoints);
  }
  var _proto = ResponsiveState.prototype;
  _proto.calculate = function calculate(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      matchMedia = _ref.matchMedia,
      initialMediaType = _ref.initialMediaType,
      initialOrientation = _ref.initialOrientation;
    var mediaType = 'xs'; // mobile first!
    var orientation = this.options.orientation; // allow constructor defined orientation

    // If there is a dom and matchMedia then we assume we are workign client side with a window-like object
    // else we assume we are SSR and expect initial settings
    if (hasDom() && matchMedia) {
      mediaType = getMediaValue(matchMedia, this.mediaQueries.breakpoints, this.options.infinity);
      orientation = getMediaValue(matchMedia, this.mediaQueries.orientation, this.options.orientation);
    } else {
      if (initialMediaType) {
        mediaType = initialMediaType;
      }
      if (initialOrientation) {
        orientation = initialOrientation;
      }
    }

    // build the responsive state
    var responsiveState = {
      breakpoints: this.options.breakpoints,
      lessThan: assertMediaTypePosition(mediaType, this.mediaOrder, 'lessThan'),
      greaterThan: assertMediaTypePosition(mediaType, this.mediaOrder, 'greaterThan'),
      is: assertMediaTypeIs(mediaType, this.options.breakpoints),
      mediaType: mediaType,
      orientation: orientation
    };

    // return calculated state
    return _extends({}, responsiveState, this.options.extraFields(responsiveState));
  };
  return ResponsiveState;
}();